import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import colors from 'components/utils/colors'

import Table from 'components/Shared/TableNew/Index'
import TableHead from 'components/Shared/TableNew/TableHead'
import TableBody from 'components/Shared/TableNew/TableBody'
import TableRow from 'components/Shared/TableNew/TableRow'
import TableCell from 'components/Shared/TableNew/TableCell'
import TableCellWithActions from 'components/Shared/TableNew/TableCellWithActions'
import TableCellAction from 'components/Shared/TableNew/TableCellAction'
import TableRowNoData from 'components/Shared/TableNew/TableRowNoData'
import Tooltip from 'components/Shared/Tooltip/Index'

import EnabledIcon from 'components/Shared/EnabledIcon/Index'
import Badge from 'components/Shared/Badge/Index'
import SatComplianceBadge from 'components/App/SatClientsPage/shared/SatComplianceBadge'

import { RouteSatSecretsPage } from 'routes'

const StyledBadge = styled(Badge)`
  margin-right: 4px;
  padding: 0 5px;
  font-size: 12px;
`

const SatClientsTable = ({ satClients, selectedSatClientId, onRowClick }) => {
  const { t } = useTranslation()

  const extractCapabilities = (capabilities) => {
    return (
      capabilities.map(capability =>
        <StyledBadge color={colors.secondary80} key={capability}>
          {capability}
        </StyledBadge>
      )
    )
  }

  const partnerSatSecretLink = (clientID) => {
    return { pathname: RouteSatSecretsPage({ satClientId: clientID }) }
  }

  return (
    <Table width='100%'>
      <TableHead withTopBorder>
        <TableRow>
          <TableCell>{t('satClientsPage.table.id')}</TableCell>
          <TableCell>{t('satClientsPage.table.clientID')}</TableCell>
          <TableCell>{t('satClientsPage.table.capabilities')}</TableCell>
          <TableCell align='center'>{t('satClientsPage.table.enabled')}</TableCell>
          <TableCell align='center'>{t('satClientsPage.table.approved')}</TableCell>
          <TableCell>{t('satClientsPage.table.compliance')}</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>

      <TableBody>
        {satClients.map(satClient =>
          <TableRow
            key={satClient.clientId}
            active={selectedSatClientId === satClient.id}
            onClick={() => onRowClick(satClient)}
          >
            <TableCell>{satClient.id}</TableCell>
            <TableCell>{satClient.clientId}</TableCell>
            <TableCell>
              {extractCapabilities(satClient.capabilities)}
            </TableCell>
            <TableCell align='center'>
              <EnabledIcon enabled={satClient.enabled} />
            </TableCell>
            <TableCell align='center'>
              <EnabledIcon enabled={satClient.approved} />
            </TableCell>
            <TableCell>
              <SatComplianceBadge status={satClient.complianceStatus} />
            </TableCell>
            <TableCellWithActions>
              <TableCellAction
                to={partnerSatSecretLink(satClient.id)}
                iconName='icon-show-requests'
                tooltip={t('satClientsPage.table.openSatSecretsTooltip')}
                tooltipId={'tooltip-open-satclient' + satClient.id}
              />
              <Tooltip id={'tooltip-open-satclient' + satClient.id} />
            </TableCellWithActions>
          </TableRow>
        )}

        <TableRowNoData data={satClients} />
      </TableBody>
    </Table>
  )
}

SatClientsTable.propTypes = {
  satClients: PropTypes.array.isRequired,
  selectedSatClientId: PropTypes.number,
  onRowClick: PropTypes.func.isRequired,
}

export default SatClientsTable
